import { render } from "./Index.vue?vue&type=template&id=1fe3f412&scoped=true"
import script from "@/assets/js/index.js?vue&type=script&lang=js"
export * from "@/assets/js/index.js?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=1fe3f412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe3f412"]])

export default __exports__